import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
const SpinLoader = (props) => {
  return <Spinner {...props} animation="border" variant="light" />;
};

export default SpinLoader;
